<template>
    <transition name="fade">
        <div id="LanguageSelection" v-show="languageSelectionVisible">
            <div class="lc-container">
                <img class="lc-logo" :src="publicPath+'/media'+mediaURL+logoURL" alt="">
                <div class="lc-title">Bitte wählen Sie eine Sprache aus:</div>

                <button v-for="language in languages" :key="language.name" class="secondary lc-language" @click="changeLanguage(language)">{{ language.name }}</button>
            </div>          
        </div>
    </transition>
</template>

<script>
import {mapGetters,mapMutations} from 'vuex';

export default {
    data: () => ({
        publicPath: process.env.BASE_URL,
        languageSelectionVisible: false
    }),
    computed: {
        ...mapGetters(['panoramaTourZIPEN','mediaURL','panoramaTourZIP','showLanguageSelection','logoURL','languages']),
    },
    methods: {
        ...mapMutations(["setActiveLanguage"]),
        changeLanguage(language){
            this.setActiveLanguage(language); // Set Language
            this.languageSelectionVisible = false;
        }
    },
    watch: {
        showLanguageSelection(){
            this.languageSelectionVisible = this.showLanguageSelection;
        }
    },
    created(){
        window.addEventListener("setLanguageSelectionVisible",(e) => {
            console.log("Set Language Selection Visible->" + e.detail.boolean);
            this.languageSelectionVisible = e.detail.boolean;
        });
    }
}
</script>

<style scoped>
#LanguageSelection{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    z-index: 1002;
}
.lc-container{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: transparent;
}
.lc-logo{
    width: 350px;
    height: auto;
}
.lc-title{
    font-weight: bolder;
    font-size: 20px;
    text-align: center;
    margin: 50px;
}
.lc-language{
    cursor: pointer;
    border: 2px solid black;
    padding: 10px;
    margin: 10px;
    color: black;
    text-align: center;
    font-size: 18px;
    width: 300px;
}
.lc-language:hover{
   background: var(--primaryColor);
   border: 2px solid var(--primaryColor);;
}
.lc-flag{
    width: 50px;
    height: auto;
    margin-right: 20px;
}
</style>